module.exports = __webpack_public_path__ + "img/whats-app.c84d24fa.svg";